import { Theme } from '@mui/material/styles';

// Helper pour obtenir le favicon d'un domaine
export const domainFavicon = (domain: string) => `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;

// Helper pour obtenir la couleur selon le niveau de compétitivité
export const getLevelColor = (level?: string, theme?: Theme) => {
    switch (level) {
        case 'high':
            return theme?.palette.error.main || '#f44336';
        case 'active':
            return theme?.palette.warning.main || '#ff9800';
        case 'low':
            return theme?.palette.success.main || '#4caf50';
        default:
            return theme?.palette.text.secondary || '#fff';
    }
};

// Helper pour obtenir le favicon d'une marque avec taille spécifique, make it async
export const brandFavicon = async (brandDomain: string, size: number = 362) => {
    const response = await fetch(`https://www.google.com/s2/favicons?domain=${brandDomain}&sz=${size}`);
    const data = await response.json();
    return data;
};

// Map API coverage string (Opportunity, Protected, Attacked) to internal level (low, active, high)
export const coverageToLevel = (coverage?: string | null): string => {
    if (!coverage) return '';
    const c = String(coverage).trim().toLowerCase();
    if (c === 'attacked') return 'high';
    if (c === 'protected') return 'active';
    if (c === 'opportunity' || c === 'savings opportunity') return 'low';
    return c;
};

// Helper to map coverage level to label (Attacked, Protected, Savings opportunity)
export const mapLevelToLabel = (level?: string) => {
    if (!level) return '';
    switch (level) {
        case 'high':
            return 'Attacked';
        case 'active':
            return 'Protected';
        case 'low':
            return 'Savings opportunity';
        default:
            return level;
    }
};

// Normaliser le niveau vers une clé canonique pour le tri
export const normalizeLevel = (level?: string): string => {
    if (!level) return '';
    const key = String(level).trim().toLowerCase();
    if (key === 'high' || key === 'active' || key === 'low') return key;
    // Accepter quelques variantes communes
    if (key === 'medium' || key === 'mid' || key === 'moderate') return 'active';
    if (key === 'severe') return 'high';
    if (key === 'light') return 'low';
    return key;
};

// Comparateur pour trier les niveaux de compétitivité
export const levelSortComparator = (level1: string, level2: string) => {
    const order: Record<string, number> = { low: 0, active: 1, high: 2 };
    const r1 = order[normalizeLevel(level1)];
    const r2 = order[normalizeLevel(level2)];
    if (r1 == null && r2 == null) return 0;
    if (r1 == null) return 1;
    if (r2 == null) return -1;
    return r1 - r2;
};

// Constantes
export const MAX_VISIBLE_COUNTRIES = 6;

export const DEFAULT_API_PARAMS = {
    sortBy: 'impressionShare',
    sortOrder: 'desc',
    search: '',
    pageSize: 50,
    page: 1,
} as const;
